module.exports = __webpack_public_path__ + "img/somoslogo.583b304a.png";